export const MAX_LABEL_SIZE = 255;
export const MAX_STRING_SIZE = 255;
export const MAX_ALLOWED_LABELS = 55;
export const LABELS_MAX_ALLOWED = 'MAX ALLOWED LABELS';
export const LABELS_INVALID = 'LABELS INVALID';
export const FORGE_LABELS_INVALID = 'FORGE LABELS INVALID';
export const STRING_INVALID = 'STRING_INVALID';
